import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import { Link } from 'react-router-dom'
import { States, useCurrentStateStore } from 'stores/useCurrentStateStore'

export const PatronDetailsTabs = ({
  currentTab,
  patronId,
}: {
  currentTab: any
  patronId: number
}) => {
  const { currentStateName } = useCurrentStateStore()

  return (
    <Tabs value={currentTab}>
      <Tab
        label="Overview"
        value={`/PatronAccounts/${patronId}/Overview`}
        to={`/PatronAccounts/${patronId}/Overview`}
        component={Link}
      />
      {currentStateName === States.ILLINOIS && (
        <Tab
          label="Check-in History"
          value={`/PatronAccounts/${patronId}/CheckInHistory`}
          to={`/PatronAccounts/${patronId}/CheckInHistory`}
          component={Link}
        />
      )}
      {currentStateName === States.ILLINOIS && (
        <Tab
          label="Activity Log"
          value={`/PatronAccounts/${patronId}/ActivityLog`}
          to={`/PatronAccounts/${patronId}/ActivityLog`}
          component={Link}
        />
      )}
      {currentStateName === States.ILLINOIS && (
        <Tab
          label="Balances"
          value={`/PatronAccounts/${patronId}/PointBalance`}
          to={`/PatronAccounts/${patronId}/PointBalance`}
          component={Link}
        />
      )}
      {currentStateName === States.ILLINOIS && (
        <Tab
          label="Badges"
          value={`/PatronAccounts/${patronId}/Badges`}
          to={`/PatronAccounts/${patronId}/Badges`}
          component={Link}
        />
      )}
      {currentStateName === States.ILLINOIS && (
        <Tab
          label="Sweepstakes"
          value={`/PatronAccounts/${patronId}/Sweepstakes`}
          to={`/PatronAccounts/${patronId}/Sweepstakes`}
          component={Link}
        />
      )}
      <Tab
        label="Notes"
        value={`/PatronAccounts/${patronId}/Notes`}
        to={`/PatronAccounts/${patronId}/Notes`}
        component={Link}
      />
    </Tabs>
  )
}
